import { useState } from 'react'
import { useEffectOnce } from 'react-use'
import { io, Socket } from 'socket.io-client'

import { socketUrl } from '~/configs/app'

import useDebugger from './useDebugger'

const useSocket = () => {
  const { debug } = useDebugger()
  const [socket, setSocket] = useState<Socket | null>(null)

  useEffectOnce(() => {
    const socketIo = io(socketUrl, {
      transports: ['websocket'],
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
    })

    socketIo.on('connect', () => {
      debug('info', 'Socket connected')
    })

    socketIo.on('disconnect', (reason: string) => {
      debug('info', 'Socket disconnected:', reason)
    })

    socketIo.on('error', (error: string) => {
      debug('info', 'Socket error:', error)
    })

    setSocket(socketIo)
  })

  return socket
}

export default useSocket
